const { gql } = require("@apollo/client");

/**
 * Save logout time at BE to fetch visiion on login
 */

export const logOutUser = gql`
  mutation logOutUser($companyId: ID!, $userId: ID!) {
    logOutUser(companyId: $companyId, userId: $userId) {
      id
    }
  }
`;

/**
 * Mark vision complete, delete
 */

export const visionBoardMutation = gql`
  mutation visionMutation($input: VisionInput!) {
    visionMutation(input: $input) {
      id
      title
      description
      visionStatus
      endDate
      logo{
        fileName
        key
        url
      }
    }
  }
`;

/**
 * Give encouragement word
 */

export const visionWordsAndCommentsMutation = gql`
  mutation visionWordsAndCommentsMutation(
    $input: VisionWordsAndCommentsInput!
  ) {
    visionWordsAndCommentsMutation(input: $input) {
      id
      comment
      encouragementWord
      createdByUserId
      isWordExist
      createdBy {
        firstName
        lastName
        profileImage {
          url
          fileName
        }
      }
    }
  }
`;

/**
 * Remove is new tag
 */

export const removeIsNewTag = gql`
  mutation removeIsNewTag($input: CreateVisionUserForNewTagInput!) {
    createVisionUserForNewTag(input: $input) {
      id
    }
  }
`;

/**
 *   change vision notification on vision card
 */

export const visionNotificationOptout = gql`
  mutation visionNotificationOptout($id: ID!, $isOptout: Boolean) {
    visionNotificationOptout(id: $id, isOptout: $isOptout) {
      id
    }
  }
`;
